
// const countries = [
//     'India', 'United States', 'Canada', 'United Kingdom', 'Australia',
//     'Germany', 'France', 'Japan', 'China', 'Brazil', 'South Africa',
//     'Russia', 'Mexico', 'Italy', 'Spain', 'Netherlands', 'Sweden', 'New Zealand', 'Other'
// ];
// const Countrycode = [
//     { value: '+91', label: '+91' },
//     { value: '+1', label: '+1' },
//     { value: '+44', label: '+44' },
//     { value: '+61', label: '+61' },
//     { value: '+81', label: '+81' },
//     { value: '+49', label: '+49' },
//     { value: '+33', label: '+33' },
//     { value: '+86', label: '+86' },
//     { value: '+55', label: '+55' },
//     { value: '+39', label: '+39' },
//     { value: '+7', label: '+7' },
//     { value: '+82', label: '+82' },
// ];

// export default Countrycode;

// mockData.js
const countries = [
    { label: 'India', value: '+91' },
    { label: 'United States', value: '+1' },
    { label: 'Canada', value: '+1' },
    { label: 'United Kingdom', value: '+44' },
    { label: 'Australia', value: '+61' },
    { label: 'Germany', value: '+49' },
    { label: 'France', value: '+33' },
    { label: 'Japan', value: '+81' },
    { label: 'China', value: '+86' },
    { label: 'Brazil', value: '+55' },
    { label: 'South Africa', value: '+27' },
    { label: 'Russia', value: '+7' },
    { label: 'Mexico', value: '+52' },
    { label: 'Italy', value: '+39' },
    { label: 'Spain', value: '+34' },
    { label: 'Netherlands', value: '+31' },
    { label: 'Sweden', value: '+46' },
    { label: 'New Zealand', value: '+64' },
    { label: 'Other', value: '' },
];

export default countries;
